import { useEffect } from 'react';

import API_BASE_PATH from '../../api/basePath';

// Code adapted from here https://www.restack.io/docs/matomo-knowledge-matomo-react-js-integration
// Matomo JS Guide https://developer.matomo.org/guides/tracking-javascript-guide
// Matomo JS API reference https://developer.matomo.org/api-reference/api-reference-introduction
const MatomoTracker = ({ siteId }) => {
  const matomoPath = `${API_BASE_PATH}/analytics/matomo`;
  const matomoUserIdFeValue = 'USER_ID';
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = matomoPath;
    document.body.appendChild(script);

    /* eslint-disable no-underscore-dangle */
    window._paq = window._paq || [];
    window._paq.push(['trackPageView']); // SPAs don't trigger a traditional page load, so this lets M know that a page has been changed
    window._paq.push(['enableLinkTracking']); // Tracks all link clicks, including middle and right mouse click, as if they were left clicks
    window._paq.push(['setTrackerUrl', matomoPath]); // This should be the endpoint to which to send the events
    window._paq.push(['setUserId', matomoUserIdFeValue]);
    window._paq.push(['setSiteId', siteId]);
    window._paq.push(['setLinkClasses', 'external']); // Track all links with the external class as external links in M.
    /* eslint-enable no-underscore-dangle */
  }, [siteId]);

  return null;
};

export default MatomoTracker;
